// extracted by mini-css-extract-plugin
export default {"footer":"shx5l5AILtd7YqE3Tzxd","stylesInputPanel":"l5dx1YLmkoI5rQf312bk","scrollToTopButton":"_FFhIGaK4SI5fKOQRuJ9","panelContentWrapper":"aznSWuB6K48xjclP2_DD"};